// SPB (Surat Pengeluaran Barang) as native ESC/P for the Epson LX-310.
// Content mirrors the HTML version in ../printSPBUtils.js; the page layout
// (boxed table, page numbers, footer) is rendered by halfFormEscp.js.

import {
  buildHalfFormDoc,
  STANDARD_COLUMNS,
  STANDARD_TOTALS,
} from "./halfFormEscp";

const fmtDate = (data) => {
  const raw = data.created_at || data.transaction_date;
  if (!raw) return "-";
  const d = new Date(raw);
  return isNaN(d.getTime()) ? "-" : d.toLocaleDateString("id-ID");
};

const CONFIG = {
  title: "SURAT PENGELUARAN BARANG (SPB)",
  infoLines: (data) => [
    ["Tanggal", fmtDate(data), "No. SJ", data.sj_number || "-"],
    [
      "No. SPB",
      data.document_number || data.spb_number || data.id,
      "Gudang Tujuan",
      data.warehouse_name || "-",
    ],
  ],
  columns: STANDARD_COLUMNS,
  groupHeader: { label: "JUMLAH", span: 2 },
  totalSpan: 5,
  totals: STANDARD_TOTALS,
  notes: (data) => data.notes || "-",
  signatureLabel: "Yang menyerahkan,",
  signatureName: (data) => data.user_username || "(_______________)",
  maxItemsPerPage: 7,
};

/**
 * Build the full ESC/P document string for an SPB.
 * @param {object} data the same data object passed to printSPB()
 * @param {number} itemsPerPage rows per page (matches the HTML paginator)
 * @returns {string} ESC/P bytes ready for qzClient.printRaw()
 */
export const buildSPBEscp = (data, itemsPerPage = 6) =>
  buildHalfFormDoc(CONFIG, data, itemsPerPage);

export default buildSPBEscp;
